import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SwiperOptions } from 'swiper';
import SwiperCore, { Pagination, Navigation } from "swiper";
import { ExpandImageDialogComponent } from 'src/app/modules/store/expand-image-dialog/expand-image-dialog.component';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { Router } from '@angular/router';
SwiperCore.use([Pagination, Navigation]);
@Component({
  selector: 'app-card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.scss']
})
export class CardDetailComponent implements OnInit {
  @Input() smallDevices;
  @Input() sliderData;
  @Input() noOfpannel;
  @Input() itemType;
  @Input() pageHeader;
  @Input() isPanelOpened;
  @Input() isPanelOpened1;
  @Input() isPanelOpened2;
  public wordLimit: number;
  public isPhone: boolean = false;
  public isMobileDevices: boolean = false;
  public isContentToggled: boolean = false;
  public descriptionLen: number;
  public showRead: boolean = false;
  constructor(
    private dialog: MatDialog,
    private commonFunction: CommonFunctions,
    private router: Router
  ) {
    this.isMobileDevices = this.commonFunction.identifyDeviceType();
  }
  ngOnInit(): void {
    if(this.sliderData && this.sliderData.portalCardImageUrl == 'assets/icon/gc_placeholder.svg'){
      this.sliderData.portalCardImageUrl = 'assets/icon/stbplaceholderlg.svg'
    }
    this.descriptionLen = this.sliderData && this.sliderData.cardDescription ? this.sliderData?.cardDescription.length : 0;
    this.isMobileDevices ? this.wordLimit = 110 : this.wordLimit = 250;
    if (this.wordLimit < this.descriptionLen) {
      this.showRead = true;
    }
  }
  config: SwiperOptions = {
    allowTouchMove: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true
    }
  };
  ngOnChanges(changes: SimpleChanges) {
  }
  expandImage(img: any) {
    const dialogRef = this.dialog.open(ExpandImageDialogComponent, {
      width: '760px',
      panelClass: 'expand-image-dialog',
      data: { storeImage: img }
    });
  }
  toggleContent() {
    if (this.isMobileDevices) {
      this.isContentToggled = !this.isContentToggled;
      if (this.isContentToggled) {
        this.wordLimit = this.descriptionLen;
      } else {
        this.wordLimit = 110;
      }
    } else {
      this.isContentToggled = !this.isContentToggled;
      if (this.isContentToggled) {
        this.wordLimit = this.descriptionLen;
      } else {
        this.wordLimit = 250;
      }
    }
  }
  gotoPrevious() {
    if(this.pageHeader === 'Buy a Digital Card'){
      this.router.navigate(['/pay/addcard'])
    }else if(this.pageHeader === 'Gift & Merchandise'){
      this.router.navigate(['/giftcards'])
    }
  }
  @Output() closePanels = new EventEmitter<any>();
  closeAllPanels() {
    this.closePanels.emit(true);
  }
}
